// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'ec081bc4d66f8d7a1fa3b366b76493e88037bff3';
export const BUILD_NUMBER = '189';
export const BUILD_TIMESTAMP = '2026-07-08T07:29:38.534Z';
